import type { SegmentId } from '../segment/segment-id';
import type { BrandSlug } from '../shared/brand-slug';
import type { OrgId, UserId } from '../shared/ids';
import type { MemberPreferences } from './member-preferences';
import type { MemberPreferencesDocument } from './member-preferences-document';

/** Reads and writes one `portal_org_member` row by its primary key; every write carries both ids. */
export abstract class MemberPreferencesRepository {
  /** Rejects when the read fails or the member has no row in the org. */
  abstract forMember(userId: UserId, orgId: OrgId): Promise<MemberPreferences>;

  abstract saveDocument(
    userId: UserId,
    orgId: OrgId,
    document: MemberPreferencesDocument
  ): Promise<void>;

  abstract saveBrandSelection(
    userId: UserId,
    orgId: OrgId,
    slugs: readonly BrandSlug[]
  ): Promise<void>;

  /** Merges one comparison's pick into the stored map; the other entries stay as stored. */
  abstract saveCategoryComparisonBrandSelection(
    userId: UserId,
    orgId: OrgId,
    segmentId: SegmentId,
    slugs: readonly BrandSlug[]
  ): Promise<void>;

  abstract markOnboarded(userId: UserId, orgId: OrgId): Promise<void>;
}
